import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import WhatsAppButton from "../../Components/UI/WhatsAppButton";
import { FileUploader, Button, Spinner } from "../../Components/UI";
import "./Registration.scss";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import { useFormik } from "formik";
import * as yup from "yup";
import { HorizontalLine } from ".";
import { connect } from "react-redux";
import {
  DeleteUserImage,
  GetImageUploadUrl,
  GetImageUrl,
  PostAdvanceDetails,
  UploadProfilePhoto,
} from "../../Store/Actions/userActionCreator";
import { isMobileView, logout, showMessage } from "../../Utils/helper";

const validationSchema = yup.object({});

// Profile photo goes through the backend so it can be checked before it is stored
const PROFILE_PHOTO_SUFFIX = "/Profile Photo";

function ProfileForm({
  dispatchGetImageUploadUrl,
  location,
  dispatchPostAdvanceDetails,
  dispatchGetImageUrl,
  dispatchDeleteUserImage,
  dispatchUploadProfilePhoto,
  ...props
}) {
  const [uploadUrlLinks, setUploadUrlLinks] = useState({});
  const [uploadedLinks, setUploadedLinks] = useState({});
  const [loading, toggleLoading] = useState(false);

  const formik = useFormik({
    initialValues: {},
    validationSchema: validationSchema,
    onSubmit: async (values, err) => {
      props.history.push("/?rg=1");
    },
  });

  const uploadProfilePhoto = (file) =>
    new Promise((resolve) => {
      const formData = new FormData();
      formData.append("file", file, "profile.jpg");
      dispatchUploadProfilePhoto(formData, resolve, () =>
        resolve({ status: false, silent: true })
      );
    });

  const fetchUploadedProfileImages = () => {
    toggleLoading(true);
    dispatchGetImageUrl(
      (resp) => {
        if (!!resp?.status) {
          setUploadedLinks(resp?.result ?? {});
        } else {
          showMessage(resp?.result || "", "error");
        }
        toggleLoading(false);
      },
      (err) => {
        toggleLoading(false);
        showMessage(err, "error");
      }
    );
  };

  useEffect(() => {
    toggleLoading(true);
    dispatchGetImageUploadUrl(
      (resp) => {
        if (!!resp?.status) {
          setUploadUrlLinks(resp?.result ?? []);
          fetchUploadedProfileImages();
        } else {
          showMessage(resp?.result || "", "error");
        }
        toggleLoading(false);
      },
      (err) => {
        showMessage(err, "error");
        toggleLoading(false);
      }
    );
  }, []);

  const profilePhotoRegex = /Profile/;
  const isSubmitButtonDisabled = Object.keys(uploadedLinks || {})?.some((e) =>
    profilePhotoRegex.test(e)
  );
  const slotKeys = Object.keys(uploadUrlLinks || {});
  const uploadedCount = slotKeys.filter((k) => !!uploadedLinks?.[k]).length;
  return (
    <Box className="registration-baisc-form">
      <WhatsAppButton />
      <Typography variant="h4" fontWeight={"bold"} color="#1e1b4b">
        Add your photos
      </Typography>
      <Typography variant="h6" color={"#434343"} marginBottom={2}>
        One last step. Clear photos help you get more responses.
      </Typography>
      <Box className="upload-tip">
        <LightbulbOutlinedIcon fontSize="small" />
        <span>
          Profile photo is mandatory. You can also upload a Family photo and
          Horoscope (Kundali) photo, or any 2 other photos you would like to
          share for better matches.
        </span>
      </Box>
      {!!slotKeys.length && (
        <Box className="upload-progress">
          <span className="upload-progress-text">
            {uploadedCount} of {slotKeys.length} uploaded
          </span>
          <div className="upload-progress-track">
            <div
              className="upload-progress-fill"
              style={{ width: `${(uploadedCount / slotKeys.length) * 100}%` }}
            />
          </div>
        </Box>
      )}
      <form onSubmit={formik.handleSubmit}>
        <Spinner loading={loading}>
          <Box
            style={{
              display: "flex",
              alignItems: "flex-start",
              flexDirection: isMobileView ? "column" : "row",
              flexWrap: "wrap",
              flexFlow: "wrap",
              minHeight: "50vh",
            }}
          >
            {slotKeys.map((key, idx) => {
              const label = key?.split("/")?.[1] ?? "";
              const isRequired = /Profile/.test(key);
              const isDone = !!uploadedLinks?.[key];
              return (
              <Box
                key={key}
                className="upload-slot"
                style={{
                  width: isMobileView ? "100%" : "32%",
                  marginBottom: "16px",
                  marginRight: "10px",
                }}
              >
                <div className="upload-slot-header">
                  <span className="upload-slot-title">{label}</span>
                  {isDone ? (
                    <span className="upload-done">
                      <CheckCircleIcon fontSize="inherit" /> Uploaded
                    </span>
                  ) : (
                    <span
                      className={`upload-badge ${
                        isRequired ? "required" : "optional"
                      }`}
                    >
                      {isRequired ? "Required" : "Optional"}
                    </span>
                  )}
                </div>
                <FileUploader
                  // label={'Upload Support Document'}
                  placeholder={`Upload ${key?.split("/")?.[1] ?? ""}`}
                  hideRemove={isRequired}
                  defaultValue={uploadedLinks[key]}
                  uploadUrl={uploadUrlLinks[key]}
                  onUpload={
                    key.endsWith(PROFILE_PHOTO_SUFFIX)
                      ? uploadProfilePhoto
                      : undefined
                  }
                  onFileUploaded={(url) => {
                    fetchUploadedProfileImages();
                  }}
                  // onRemoved={() => {
                  //   const newList = { ...uploadedLinks };
                  //   delete newList[key];
                  //   setUploadedLinks(newList);
                  // }}
                  onRemoved={() => {
                    toggleLoading(true);
                    dispatchDeleteUserImage(
                      key.split("/")[1],
                      (resp) => {
                        const newList = { ...uploadedLinks };
                        delete newList[key];
                        setUploadedLinks(newList);
                        toggleLoading(false);
                      },
                      (err) => {
                        toggleLoading(true);
                      }
                    );
                  }}
                />
              </Box>
              );
            })}
          </Box>
          <Box
            style={{
              position: isMobileView ? "relative" : "absolute",
              bottom: 0,
              width: "100%",
            }}
          >
            <HorizontalLine />
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
                justifyContent: "center",
              }}
            >
              <Button
                variant="contained"
                size="large"
                type="submit"
                endIcon={
                  <ArrowForwardOutlinedIcon
                    htmlColor="#ffffff"
                    fontSize="small"
                  />
                }
                style={{
                  fontFamily: "Roboto",
                  fontWeight: 700,
                  color: "#ffffff",
                }}
                disabled={!isSubmitButtonDisabled}
              >
                Save
              </Button>
            </Box>
          </Box>
        </Spinner>
      </form>
    </Box>
  );
}

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchGetImageUploadUrl: (onSuccess, onError) =>
    dispatch(GetImageUploadUrl(onSuccess, onError)),
  dispatchGetImageUrl: (onSuccess, onError) =>
    dispatch(GetImageUrl(onSuccess, onError)),
  dispatchPostAdvanceDetails: (payload, onSuccess, onError) =>
    dispatch(PostAdvanceDetails(payload, onSuccess, onError)),
  dispatchDeleteUserImage: (data, onSuccess, onError) =>
    dispatch(DeleteUserImage(data, onSuccess, onError)),
  dispatchUploadProfilePhoto: (data, onSuccess, onError) =>
    dispatch(UploadProfilePhoto(data, onSuccess, onError)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileForm);
